import { DomSanitizer } from '@angular/platform-browser';
import {catchError} from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoadingService } from '../../shared/services/loading.service';

import swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { AppConfigService } from '../../shared/services/app.config.service';

@Injectable()
export class AuthHttp {
    private logger: string;
    private user: string;

    constructor(
        private http: HttpClient,
        private authService: AuthenticationService,
        private router: Router,
        private loadingService: LoadingService,
        private sanitizer: DomSanitizer,
        private config : AppConfigService
    ) { }

private buildUrl(endpoint: string): string {

        if (/^https?:\/\//i.test(endpoint)) {
            throw new Error('Absolute URLs are not allowed');
        }
        return this.config.API_BASE + endpoint;
    }

    private createHeaders(): HttpHeaders {

        this.logger = sessionStorage.getItem('logger') || '';
        this.user = sessionStorage.getItem('lastLoggedInUser') || '';

        const token = this.authService.getToken();

        let headers = new HttpHeaders()
            .set('logger', this.logger)
            .set('user', this.user);

        if (token) {
            headers = headers.set('Authorization', `Bearer ${token}`);
        }

        return headers;
    }

    get(endpoint: string) {
        const url = this.buildUrl(endpoint);

        return this.http.get(url, {
            headers: this.createHeaders()
        }).pipe(
            catchError(err => this.handleError(err)) //replaced .catch()
        );
    }

    post(endpoint: string, data: any) {
        const url = this.buildUrl(endpoint);
        data = this.addMedium(data);

        return this.http.post(url, data, {
            headers: this.createHeaders()
                .set('Content-Type', 'application/json')
        }).pipe(
            catchError(err => this.handleError(err))
        );
    }

    put(endpoint: string, data: any) {
        const url = this.buildUrl(endpoint);
        data = this.addMedium(data);

        return this.http.put(url, data, {
            headers: this.createHeaders()
                .set('Content-Type', 'application/json')
        }).pipe(
            catchError(err => this.handleError(err))
        );
    }

    delete(endpoint: string) {
        const url = this.buildUrl(endpoint);

        return this.http.delete(url, {
            headers: this.createHeaders()
        }).pipe(
            catchError(err => this.handleError(err))
        );
    }

    addMedium(data: any) {
        try {
            if (typeof data === 'string') {
                data = JSON.parse(data);
                data.medium = 'mobile';
                data = JSON.stringify(data);
            } else {
                data.medium = 'mobile';
            }
        } catch (error) {
            console.log(error);
        }
        return data;
    }

    refreshExpiredToken(): Observable<any> {
        const userInfo = this.authService.getUserInfo();
        const username = userInfo.username != null ? userInfo.username : userInfo.userName;
        const refreshToken = this.authService.getRefreshToken();
        const obs =  new Observable((observer) => {
          this.authService.getAuthRefreshToken(username, refreshToken).subscribe((response: any) => {
            this.authService.logOut();
            this.authService.setLoggedInUser(response.access_token);
            this.authService.setTokenExpirationTime(response.expiry_date);
            this.authService.setRefreshToken(response.refresh_token);

            observer.next(response.access_token);
            observer.complete();
            this.authService.setLastTokenRefreshTime();
        }, (error) => {
          observer.error(error);
          observer.complete();
        });
    });

        return obs;
    }

    getAuthorizationHeader() {
        if (this.isTokenExpired()) {
            try {
                const userInfo = this.authService.getUserInfo();
                const refreshToken = this.authService.getRefreshToken();
                this.authService.getAuthRefreshToken(userInfo.username, refreshToken).subscribe((response: any) => {
                    this.authService.logOut();
                    this.authService.setLoggedInUser(response.access_token);
                    this.authService.setTokenExpirationTime(response.expiry_date);
                    this.authService.setRefreshToken(response.refresh_token);
                    this.authService.setLastTokenRefreshTime();
                    return response.access_token;
                });
            } catch (err) {
                this.handleRefreshTokenError(err);
            }
            // this.authService.logOut();
        }
        return this.authService.getToken();
    }

    createAuthorizationHeader(headers: HttpHeaders, includect: boolean) {
        if (this.isTokenExpired()) {
            //     this.authService.logOut();
        }
        const token = this.authService.getToken();
        if (includect === true) {
             headers.append('Content-Type', 'application/json');
        }
        if (this.authService.isUserLoggedIn() && token ) {
             headers.append('Authorization', `Bearer ${token}`);
        }

    }

    private isTokenExpired(): boolean {
        const currDate = new Date(Date.now());
        const tokenExpiration = new Date(this.authService.getTokenExpirationTime());
        return currDate >= tokenExpiration;
    }

    handleError(error: any) {
        if (error.status === 403) {
            this.authService.logOut();
            this.loadingService.hide(1000);

            swal(
                'Access denied!',
                'You have been locked out temporarily.',
                'error'
            );

            return this.router.navigate(['/auth/login']);
        }

        if (error.status === 401) {
            try {
                const userInfo = this.authService.getUserInfo();
                const refreshToken = this.authService.getRefreshToken();
                const username = userInfo.username || userInfo.userName;

                this.authService.getAuthRefreshToken(username, refreshToken)
                    .subscribe((response: any) => {
                        this.authService.logOut();
                        this.authService.setLoggedInUser(response.access_token);
                        this.authService.setTokenExpirationTime(response.expiry_date);
                        this.authService.setRefreshToken(response.refresh_token);
                        this.authService.setLastTokenRefreshTime();
                    });

            } catch (err) {
                this.handleRefreshTokenError(err);
            }

            return null;
        }
    }

    handleRefreshTokenError(error: any) {
        if (error.status === 401) {
            this.authService.logOut();
            return this.router.navigate(['/auth/login']);
        }
    }


    refreshToken() {


        return new Observable((observer) => {
            const userInfo = this.authService.getUserInfo();
            const refreshToken = this.authService.getRefreshToken();
            const username = userInfo.username ? userInfo.username : userInfo.userName;
            this.authService.getAuthRefreshToken(username, refreshToken).subscribe((response: any) => {
                this.authService.logOut();
                this.authService.setLoggedInUser(response.access_token);
                this.authService.setTokenExpirationTime(response.expiry_date);
                this.authService.setRefreshToken(response.refresh_token);
                this.authService.setNextRefreshTime();
                observer.next(response.access_token);
                this.authService.setLastTokenRefreshTime();
            }, () => {
                console.log('token refresh failed');
                this.authService.bounceUserOut();
            });
          });
    }

}
